import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';

import { renderInput, SearchSelectField } from 'src/components/misc/redux-form-helpers';
import { isBlank } from 'src/components/misc/validations';
import autoBind from 'react-autobind';
import RaisedButton from 'material-ui/RaisedButton';
import { isInteger, isMoneyAmount, validatePrice } from 'src/common';

const ZONE_TYPES = Object.freeze({
    SINGLE_ZONE: 'single_zone',
    BETWEEN_ZONES: 'between_zones',
});

class ZoneCalculationForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            activeZone: ZONE_TYPES.SINGLE_ZONE,
        };
    }

    componentWillMount() {
        const { isCreate, initialValues } = this.props;
        if (!isCreate) {
            const activeZone = initialValues.zoneB != null ? ZONE_TYPES.BETWEEN_ZONES : ZONE_TYPES.SINGLE_ZONE;
            this.setState({ activeZone });
        }
    }

    render() {
        const { handleSubmit, t, zoneA, zoneB, geofenceAreas, isCreate, busCompany, countryCalculation } = this.props;
        const { activeZone } = this.state;

        return (
            <>
                {isCreate && (
                    <div className="col-md-12 ">
                        <div className="bf-zone-type-wrapper">
                            <div
                                className={`bf-zone-type-item ${activeZone === ZONE_TYPES.SINGLE_ZONE ? 'active' : ''}`}
                                onClick={() => {
                                    this.props.dispatch(change('zoneCalculationForm', 'zoneB', ''));
                                    this.props.change('activeZone', ZONE_TYPES.SINGLE_ZONE);
                                    this.setState({ activeZone: ZONE_TYPES.SINGLE_ZONE });
                                }}>
                                {t('zone_calculation.one_zone')}
                            </div>
                            <div
                                className={`bf-zone-type-item ${activeZone === ZONE_TYPES.BETWEEN_ZONES ? 'active' : ''}`}
                                onClick={() => {
                                    this.props.change('activeZone', ZONE_TYPES.BETWEEN_ZONES);
                                    this.setState({ activeZone: ZONE_TYPES.BETWEEN_ZONES });
                                }}>
                                {t('zone_calculation.two_zones')}
                            </div>
                        </div>
                    </div>
                )}
                <div className="col-md-12 bf-zone-form">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <Field value={this.state.activeZone} component="input" type="hidden" />
                            <div className="col-md-6">
                                <Field
                                    name="zoneA"
                                    t={t}
                                    label={`${t('zone_calculation.form.zone_a')} *`}
                                    component={SearchSelectField}
                                    filteredOptions={geofenceAreas}
                                    options={geofenceAreas}
                                />
                                {zoneA && (
                                    <div
                                        className="btn btn-xs transparent"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.props.setShowOnMap(zoneA)}>
                                        <span className="glyphicon glyphicon-map-marker" />{' '}
                                        {t('geofence.action.show_on_map')}
                                    </div>
                                )}
                            </div>
                            {ZONE_TYPES.BETWEEN_ZONES === activeZone && (
                                <div className="col-md-6">
                                    <Field
                                        name="zoneB"
                                        t={t}
                                        label={`${t('zone_calculation.form.zone_b')} *`}
                                        component={SearchSelectField}
                                        filteredOptions={geofenceAreas}
                                        options={geofenceAreas}
                                    />
                                    {zoneB && (
                                        <div
                                            className="btn btn-xs transparent"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => this.props.setShowOnMap(zoneB)}>
                                            <span className="glyphicon glyphicon-map-marker" />{' '}
                                            {t('geofence.action.show_on_map')}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="col-md-4">
                                <Field
                                    name="name"
                                    label={`${t('zone_calculation.form.name')}*`}
                                    component={renderInput}
                                />
                            </div>
                            <div className="col-md-2">
                                <Field
                                    name="flatRate.amount"
                                    label={`${t('zone_calculation.form.flat_rate')}*`}
                                    component={renderInput}></Field>
                            </div>
                            <div className="col-md-2">
                                <Field
                                    name="maxAmountIntermediates"
                                    label={`${t('zone_calculation.form.max_amount_intermediates')}*`}
                                    component={renderInput}
                                    type="number"
                                />
                            </div>
                            {isCreate && (
                                <div className="col-md-4">
                                    <RaisedButton
                                        key="successButton"
                                        label={
                                            this.props.isCreate
                                                ? t('zone_calculation.form.submit')
                                                : t('zone_calculation.form.edit')
                                        }
                                        primary={true}
                                        type="submit"
                                        labelColor="#ffffff"
                                    />
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};

    if (!values.zoneA) errors.zoneA = t('error_missing.fill_in_zone');
    if (values.zoneA && typeof values.zoneA != 'object') errors.zoneA = t('error_missing.fill_in_existing_zone');

    if (values.activeZone && values.activeZone === ZONE_TYPES.BETWEEN_ZONES) {
        if (!values.zoneB) errors.zoneB = t('error_missing.fill_in_zone');
        if (values.zoneB && typeof values.zoneB != 'object') errors.zoneB = t('error_missing.fill_in_existing_zone');
        if (values.zoneA != null && values.zoneB != null) {
            if (values.zoneB.id === values.zoneA.id) {
                errors.zoneB = t('error_missing.zone_a_and_b_are_identical');
                errors.zoneA = t('error_missing.zone_a_and_b_are_identical');
            }
        }
    }

    if (!isMoneyAmount(values.flatRate)) {
        if (!errors.flatRate) errors.flatRate = {};
        errors.flatRate.amount = t('error_missing.fill_in_flat_rate_price');
    } else if (validatePrice(values.flatRate.amount)) {
        if (!errors.flatRate) errors.flatRate = {};
        errors.flatRate.amount = `${t('error_hint.error_invalid_format')} (######.00)`;
    }

    if (!isInteger(values.maxAmountIntermediates)) errors.maxAmountIntermediates = t('error_hint.error_integer');
    else if (values.maxAmountIntermediates < 0) errors.maxAmountIntermediates = t('error_hint.error_negative');

    if (isBlank(values.name)) errors.name = t('error_missing.fill_in_name');
    else if (values.name.length > 50) errors.name = t('error_hint.error_name_length');

    return errors;
};

const selector = formValueSelector('zoneCalculationForm');

const mapStateToProps = state => ({
    zoneA: selector(state, 'zoneA'),
    zoneB: selector(state, 'zoneB'),
    activeZone: selector(state, 'activeZone'),
});

export default reduxForm({
    form: 'zoneCalculationForm',
    validate,
    onSubmitSuccess: (result, dispatch, props) => {
        props.reset();
    },
})(connect(mapStateToProps)(ZoneCalculationForm));
